//M.D 타입의 날짜 변환

function formatTimeHHMM(date) {
  const hours = date.getHours().toString().padStart(2, "0"); // 시간을 2자리로 표시하고, 한 자리 수일 경우 앞에 0을 추가합니다.
  const minutes = date.getMinutes().toString().padStart(2, "0"); // 분을 2자리로 표시하고, 한 자리 수일 경우 앞에 0을 추가합니다.
  const currentTime = hours + minutes; // 시간과 분을 합쳐서 반환합니다.
  return currentTime;
}

export { formatTimeHHMM };
